<num-dataportal-header role="banner"></num-dataportal-header>
<mat-sidenav-container autosize fullscreen class="sidenav-container fix-overlay">
  <mat-sidenav
    *ngIf="showSideNav"
    fixedInViewport
    [attr.role]="isHandset ? 'dialog' : 'navigation'"
    [attr.aria-label]="'APPLAYOUT.SIDENAV.LABEL' | translate"
    [mode]="isHandset ? 'over' : 'side'"
    [opened]="true"
    [class.expanded]="isSideMenuExpanded"
    [class.collapsed]="!isSideMenuExpanded"
  >
    <num-side-menu
      class="side-menu"
      fxFlex="100"
      class="side-menu"
      fxFlex="100"
      [isSideMenuExpanded]="isSideMenuExpanded"
      (toggleSideMenu)="isSideMenuExpanded = $event"
    ></num-side-menu>
  </mat-sidenav>

  <mat-sidenav-content fxLayout="column" class="fix-overlay padding-left-4">
    <div
      class="safari-fix"
      fxLayout="row"
      fxLayoutAlign="start start"
      role="presentation"
      fxFlexFill
    >
      <main fxFlexFill fxLayout="column" fxLayoutAlign="start start" fxFlex="95%">
        <div [@routeAnimations]="prepareRoute(outlet)" class="fullscreen">
          <router-outlet #outlet="outlet"></router-outlet>
        </div>
      </main>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
